import style from "../../../../assets/scss/common/modal/addChildModal.module.scss";
import React from "react";
import {InitialProfileInfoDTO, ProfileErrorDTO} from "../../../../types/user";
import {useTranslation} from "react-i18next";

interface Args{
    profileInfo: InitialProfileInfoDTO;
    setProfileInfo: React.Dispatch<React.SetStateAction<InitialProfileInfoDTO>>;
    errors: ProfileErrorDTO;
}
export function ChildNameField({profileInfo, setProfileInfo, errors}:Args) {
    const { t } = useTranslation("profileInfo");
    return (
        <div className={style.infoContainer}>
              <span className={style.infoText}>
                <span className={style.requireText}>
                    {t('profileInfo.addModal.required')}
                </span> {t('profileInfo.addModal.name.label')}
              </span>
            <input
                name="name"
                value={profileInfo.name}
                onChange={(e) => setProfileInfo({...profileInfo, name: e.target.value})}
                placeholder={t('profileInfo.addModal.name.placeholder')}
                className={style.inputField}
            />
            {errors.name && <div className={style.errorText}>{errors.name}</div>}
        </div>
    )
}